/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./states.vue?vue&type=template&id=3252442c&scoped=true"
import script from "./states.vue?vue&type=script&lang=js"
export * from "./states.vue?vue&type=script&lang=js"
import style0 from "./states.vue?vue&type=style&index=0&id=3252442c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252442c",
  null
  
)

export default component.exports